/**
 * Product Variant Picker - Wild Creation Station
 * Reads product data from window.WCSProduct (set by main-product.liquid)
 *
 * Shopify product JSON has options: ["Size","Color"] and variants[].option1/option2.
 * It does NOT have options_with_values. Selections must be seeded from the DOM
 * (Liquid already marks the current size/color .selected) so a size click
 * still matches Size|Color (e.g. 2X|Black) instead of falling back to S.
 */
(function() {
  const productData = window.WCSProduct || { variants: [], options: [] };
  const variants = productData.variants || [];

  const variantMap = {};
  variants.forEach(function(v) {
    const key = [v.option1, v.option2, v.option3].filter(Boolean).join('|');
    variantMap[key] = { id: v.id, price: v.price, available: v.available, img: (v.featured_image && v.featured_image.src) || null };
  });

  const optionNames = (productData.options || []).map(function(o) {
    const name = (typeof o === 'string') ? o : (o && o.name) || '';
    return name.toLowerCase().replace(/\s+/g, '-');
  });

  const selections = {};

  function seedFromDom() {
    document.querySelectorAll('.option-group').forEach(function(group, idx) {
      var sel = group.querySelector('.option-btn.selected') || group.querySelector('.option-btn');
      if (!sel) return;
      sel.classList.add('selected');
      var val = sel.getAttribute('data-value') || '';
      selections[idx] = val;
      var nameEl = document.getElementById('selected-' + (optionNames[idx] || ''));
      if (nameEl) nameEl.textContent = val;
    });
  }

  function currentKey() {
    var n = Math.max(
      Object.keys(selections).length,
      document.querySelectorAll('.option-group').length
    );
    var parts = [];
    for (var i = 0; i < n; i++) {
      if (selections[i]) parts.push(selections[i]);
    }
    return parts.join('|');
  }

  function findVariant() {
    var key = currentKey();
    if (variantMap[key]) return variantMap[key];
    var size = selections[0];
    if (size) {
      var prefix = size + '|';
      var keys = Object.keys(variantMap);
      for (var i = 0; i < keys.length; i++) {
        if (keys[i].indexOf(prefix) === 0) return variantMap[keys[i]];
      }
      if (variantMap[size]) return variantMap[size];
    }
    return null;
  }

  // wcs-variant-image 2026-10-09: on a Color pick, show that variant's featured image
  // (or the product's first image when the variant has none) via the existing thumbs/changeImage.
  function fileKey(u) {
    return String(u || '').split('?')[0].split('/').pop();
  }

  function updateImage(variant) {
    var main = document.getElementById('main-image');
    if (!main || !variant) return;
    var src = variant.img || productData.featured_image;
    if (!src) return;
    var key = fileKey(src);
    var thumbs = document.querySelectorAll('.product-images .thumb');
    for (var i = 0; i < thumbs.length; i++) {
      if (fileKey(thumbs[i].dataset.full) === key) {
        window.changeImage(thumbs[i]);
        return;
      }
    }
    main.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=800';
  }

  function money(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function updateDisplay() {
    var priceEl = document.getElementById('price-display');
    var variantInput = document.getElementById('variant-input');
    var cartBtn = document.getElementById('add-to-cart-btn');
    var variant = findVariant();

    if (variant) {
      var priceStr = money(variant.price);
      if (priceEl) priceEl.textContent = priceStr;
      if (variantInput) variantInput.value = variant.id;
      if (cartBtn) {
        cartBtn.textContent = 'Add to Cart — ' + priceStr;
        cartBtn.disabled = !variant.available;
      }
    } else if (variants.length === 1) {
      var v0 = variants[0];
      var p0 = money(v0.price);
      if (priceEl) priceEl.textContent = p0;
      if (variantInput) variantInput.value = v0.id;
      if (cartBtn) {
        cartBtn.textContent = 'Add to Cart — ' + p0;
        cartBtn.disabled = !v0.available;
      }
    }
  }

  window.selectOption = function(el) {
    try {
      var idx = parseInt(el.getAttribute('data-option-index'), 10);
      var value = el.getAttribute('data-value');
      if (isNaN(idx)) return;
      selections[idx] = value;
      el.parentElement.querySelectorAll('.option-btn').forEach(function(btn) {
        btn.classList.remove('selected');
      });
      el.classList.add('selected');
      var nameEl = document.getElementById('selected-' + (optionNames[idx] || ''));
      if (nameEl) nameEl.textContent = value;
      var key = currentKey();
      var variant = findVariant();
      console.log('[WCS] selectOption idx=' + idx + ' value=' + value + ' key=' + key + ' variant=' + (variant ? variant.id + ' ' + money(variant.price) : 'NOT FOUND'));
      updateDisplay();
      if (optionNames[idx] === 'color' || optionNames[idx] === 'colour') updateImage(variant);
    } catch (e) {
      console.error('[WCS] selectOption error', e);
    }
  };

  window.changeImage = function(thumb) {
    var main = document.getElementById('main-image');
    if (main) main.src = thumb.dataset.full;
    document.querySelectorAll('.thumb').forEach(function(t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  };

  // wcs-url-variant 2026-10-09: with ?variant=<id>, show that variant's featured image on load
  // (same path as a swatch click). Without the param nothing changes.
  function imageFromUrl() {
    try {
      var id = new URLSearchParams(window.location.search).get('variant');
      if (!id) return;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === id) {
          var v = variants[i];
          updateImage({ img: (v.featured_image && v.featured_image.src) || null });
          return;
        }
      }
    } catch (e) {
      console.error('[WCS] imageFromUrl error', e);
    }
  }

  function init() { seedFromDom(); updateDisplay(); imageFromUrl(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
